import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import About from "./About";
import Contact from "./Contact";
import bgvid from "../Utils/bgvid.mp4";
import "./Home.css";
import "./Testimonial.css";

// Import images
import testimonial1 from "../Utils/test-11.jpg";
import testimonial2 from "../Utils/test-1.jpg";
import testimonial3 from "../Utils/test-3.jpg";
import ocImg from "../Utils/s1.png";
import olImg from "../Utils/s2.png";
import wmImg from "../Utils/s3.png";
import tpImg from "../Utils/s4.png";
import case1 from "../Utils/case-1.jpg";
import case2 from "../Utils/case-2.jpg";
import case3 from "../Utils/case-3.png";
import case4 from "../Utils/case-4.png";

const Home = () => {
  const navigate = useNavigate();

  const testimonialsData = [
    {
      name: "Ramesh",
      image: testimonial1,
      text: "As per my knowledge not any other share trading institution provide this much help which SPI is providing to their students. All trainers are very dedicated and have lots of knowledge.",
    },
    {
      name: "Kamal Dan",
      image: testimonial2,
      text: "SPI has been instrumental in my trading journey. The resources and support are top-notch. I highly recommend it!",
    },
    {
      name: "Venkat",
      image: testimonial3,
      text: "I was a complete beginner before joining SPI. Now, I feel confident in making informed trading decisions. Thank you, SPI!",
    },
  ];

  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const handleViewAllClick = () => navigate("/services");
  const handleJoinClick = () => navigate("/contact");
  const handleJoinClickCourses = () => navigate("/services");

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonialsData.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonialsData.length]);

  const handleDotClick = (index) => setCurrentTestimonial(index);

  return (
    <div className="home-wrapper">
      {/* Hero Section with Video */}
      <section style={{height:"700px"}} className="hero-section">
        <video autoPlay loop muted playsInline className="hero-video">
          <source src={bgvid} type="video/mp4" />
        </video>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-7 col-md-8">
                <div className="hero-text">
                  <h1 className="hero-title">
                    <span className="highlight-letter">S</span>tart your{" "}
                    <span className="highlight-letter">P</span>rofitable
                  </h1>
                  <h1 className="hero-title">
                    <span className="highlight-letter">i</span>nvestment journey with
                  </h1>
                  <h1 className="hero-title brand-name">SPi Academi</h1>
                  <p className="hero-description">
                    At SPI Academi, we are dedicated to empowering aspiring traders with the knowledge 
                    and tools needed to excel in the financial markets. Our carefully designed programs 
                    offer a perfect blend of theoretical knowledge and practical application.
                  </p>
                  <div className="hero-buttons">
                    <button onClick={handleJoinClick} className="btn-primary">
                      Join SPi Academi
                    </button>
                    <button onClick={handleViewAllClick} className="btn-secondary">
                      Explore Courses
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Marquee Ticker */}
      <div className="marquee-wrapper">
        <div className="marquee-track">
          <div className="marquee-content">
            <span>🚀 Welcome to <strong>SPi Academi</strong></span>
            <span className="marquee-divider">|</span>
            <span>💹 Empowering Excellence in Stock Market Education</span>
            <span className="marquee-divider">|</span>
            <span>🎯 Your journey to mastery starts here. Welcome aboard!</span>
            <span className="marquee-divider">|</span>
            <span>📈 Learn. Trade. Succeed.</span>
          </div>
          <div className="marquee-content">
            <span>🚀 Welcome to <strong>SPi Academi</strong></span>
            <span className="marquee-divider">|</span>
            <span>💹 Empowering Excellence in Stock Market Education</span>
            <span className="marquee-divider">|</span>
            <span>🎯 Your journey to mastery starts here. Welcome aboard!</span>
            <span className="marquee-divider">|</span>
            <span>📈 Learn. Trade. Succeed.</span>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <div className="section-header">
            <h2>
              What's in <span>SPi Academi?</span>
            </h2>
            <p>A huge range of resources to help you sharpen your trading skills.</p>
          </div>
          <div className="features-grid">
            {[
              { icon: ocImg, title: "Online Courses", desc: "Online Trading Courses are specialized programs designed to teach individuals how to trade in financial markets." },
              { icon: olImg, title: "Online Live", desc: "Online Live Trading refers to real-time trading sessions conducted over the internet, where participants observe or actively trade under expert guidance." },
              { icon: wmImg, title: "Wealth Management", desc: "Wealth Management is a comprehensive financial service focusing on managing an individual's or family's wealth to achieve financial goals." },
              { icon: tpImg, title: "Trading Psychology", desc: "Trading Psychology refers to understanding and managing emotions like fear and greed to make better trading decisions." }
            ].map((feature, index) => (
              <div className="feature-card" key={index}>
                <div className="feature-icon">
                  <img src={feature.icon} alt={feature.title} />
                </div>
                <h4>{feature.title}</h4>
                <p>{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="divider"></div>
      <About />
      <div className="divider"></div>

      {/* Courses Section */}
      <section className="courses-section">
        <div className="container">
          <div className="section-header">
            <h2>
              Online Trading <span>Course</span>
            </h2>
          </div>
          <div className="courses-grid">
            {[
              { img: case1, title: "How does trading work?", desc: "Find out about the people and organizations who make the trading world tick." },
              { img: case2, title: "Introducing the financial markets", desc: "Take a tour of the financial markets. Discover how they operate." },
              { img: case3, title: "Trading psychology", desc: "Prepare yourself to handle the emotions you'll experience while trading." },
              { img: case4, title: "Understanding risk and reward", desc: "Discover five simple rules to help you manage risk." }
            ].map((course, index) => (
              <div className="course-card" key={index}>
                <img src={course.img} alt={course.title} />
                <div className="course-body">
                  <h5>{course.title}</h5>
                  <p>{course.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-4">
            <button onClick={handleViewAllClick} className="btn-outline-primary">
              See All Courses →
            </button>
          </div>
        </div>
      </section>

      <div className="divider"></div>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="container">
          <div className="section-header">
            <h2>Testimonials</h2>
            <p>What our students say about us</p>
          </div>
          <div className="testimonial-card-wrapper">
            <div className="testimonial-card">
              <div className="testimonial-image-wrapper">
                <img src={testimonialsData[currentTestimonial].image} alt={testimonialsData[currentTestimonial].name} />
              </div>
              <div className="testimonial-content">
                <span className="quote-icon">"</span>
                <p className="testimonial-text">{testimonialsData[currentTestimonial].text}</p>
                <h4>{testimonialsData[currentTestimonial].name}</h4>
                <div className="testimonial-rating">⭐⭐⭐⭐⭐</div>
              </div>
            </div>
            <div className="testimonial-dots">
              {testimonialsData.map((_, index) => (
                <span
                  key={index}
                  className={`dot ${index === currentTestimonial ? 'active' : ''}`}
                  onClick={() => handleDotClick(index)}
                ></span>
              ))}
            </div>
            <div className="text-center mt-4">
              <button onClick={handleJoinClickCourses} className="btn-primary">
                View Courses
              </button>
            </div>
          </div>
        </div>
      </section>

      <Contact />
    </div>
  );
};

export default Home;